import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntFarmOwner } from "../../../models/farmOwners";
import { useAddFarmOwnerMutation, useDeleteFarmOwnerMutation, useEditFarmOwnerMutation } from "../../../redux/api/farmOwners/farmOwnersApi";
import { getCookie } from "typescript-cookie";



const useFarmOwners = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addFarmOwner] = useAddFarmOwnerMutation();
    const [deleteFarmOwner] = useDeleteFarmOwnerMutation();
    const [editFarmOwner] = useEditFarmOwnerMutation();

    async function onAddFarmOwner(newFarmOwner: EntFarmOwner): Promise<boolean> {
        try {
            let status: boolean = false;
            await addFarmOwner(newFarmOwner).then((response: any) => {
                   if (response.error) {
                                               const isKyrgyz = getCookie('i18next') === 'ky';
                                               const lang = isKyrgyz ? 'kg' : 'ru';
                                               const res = response.error.data?.res;
                                               const errorMessages = Array.isArray(res)
                                                   ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                                   : response.error.data?.msg || t('unknownError'); 
                                               throw new Error(errorMessages);
                                           }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });

            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }


    async function onDeleteFarmOwner(farmOwner: EntFarmOwner) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteFarmOwner(farmOwner.id).then((response: any) => {
                        if (response.error) {
                            const isKyrgyz = getCookie('i18next') === 'ky';
                            const lang = isKyrgyz ? 'kg' : 'ru';
                            const res = response.error.data?.res;
                            const errorMessages = Array.isArray(res)
                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                : response.error.data?.msg || t('unknownError'); 
                            throw new Error(errorMessages);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({ title: t('msg.successDelete') });
                            if (refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });

                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    };
    async function onEditFarmOwner(editedFarmOwner: EntFarmOwner): Promise<boolean> {
        try {
            let status: boolean = false;
            await editFarmOwner(editedFarmOwner).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    Modal.success({ title: t('msg.successEdited') });
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    };
    return { onAddFarmOwner, onDeleteFarmOwner, onEditFarmOwner }

}
export { useFarmOwners };

